
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";

export default function QuestionAction({ discussion, isEdit, setIsEdit, onReloadNeeded }) {
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleRemove = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.discussionRemove({
			token: LoginHelper.getToken(),
			discussion_id: discussion.id,
		}).then((result) => {
			setIsLoading(false);
			navigate('/discussion_list/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<>
			<div className="bg-white rounded-[10px] p-[10px]">
				<div className="flex flex-row">
					<div className="cursor-pointer text-[#4B5155] font-Vazir-800 text-[14px] rounded-[10px] bg-[#F0F6FC] px-[10px] py-[5px]" onClick={() => setIsEdit(!isEdit)}>
						ویرایش
					</div>
					<div className="spacer p-[2px]"></div>
					<div className="cursor-pointer text-white font-Vazir-800 text-[14px] rounded-[10px] bg-[#CC0000] px-[10px] py-[5px]" onClick={() => setIsOpen(!isOpen)}>
						حذف
					</div>
				</div>
				{isOpen && (
					<>
						<div className="spacer p-[15px]"></div>
						<div>
							<div className="text-[#4B5155] font-Vazir-800 text-[14px]">
								آیا از حذف سوال مطمئن هستید؟
							</div>
							<div className="spacer p-[5px]"></div>
							<div className="flex flex-row items-center">
								<div className="cursor-pointer text-[#4B5155] font-Vazir-800 text-[14px] rounded-[10px] bg-[#F0F6FC] px-[10px] py-[5px]"
									onClick={() => setIsOpen(!isOpen)}>
									خیر
								</div>
								<div className="spacer p-[2px]"></div>
								<div className="min-w-[50px] h-[30px]">
									<Button
										onClick={() => { handleRemove() }}
										label={"بله"}
										isLoading={isLoading}
										color="#CC0000"
										textColor="#ffffff"
									/>
								</div>
							</div>
							{errorMessage && (
								<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
							)}
						</div>
					</>
				)}
			</div>
		</>
	)
}
